export default (msg) => {
  console.log("%c EASYMOVIE::%c " + msg,
    "background: linear-gradient(129deg, #1156a3, #4980d0 30%, #68dbbc); color:#FFF; padding:1px; border-radius: 3px 0 0 3px;",
    "background: #fff; color: #6C0085; border: 1px solid #68dbbc; border-radius: 0 3px 3px 0;"
  );
}
